import { httpCall, httpMethod } from "../../service";

export const loadOrders = (appDbPrefix, before, after, search, page, company, versionFrom, versionTo, potential, platform) => {
    return httpCall(httpMethod.GET, `/${appDbPrefix}/orders/${page}?after=${after}&before=${before}&search=${search}` + (!!company ? `&company=${encodeURIComponent(company)}` : '') + (!!versionFrom ? `&versionFrom=${encodeURIComponent(versionFrom)}` : '') + (!!versionTo ? `&versionTo=${encodeURIComponent(versionTo)}` : '') + (!!potential ? `&potential=true` : '') + (!!platform ? `&platform=${encodeURIComponent(platform)}` : ''))
}

export const loadMagnitudeOrders = (appDbPrefix, before, after, search, page, company, versionFrom, versionTo, potential, platform) => {
    return httpCall(httpMethod.GET, `/${appDbPrefix}/magnitude/orders/${page}?after=${after}&before=${before}&search=${search}` + (!!company ? `&company=${encodeURIComponent(company)}` : '') + (!!versionFrom ? `&versionFrom=${encodeURIComponent(versionFrom)}` : '') + (!!versionTo ? `&versionTo=${encodeURIComponent(versionTo)}` : '') + (!!potential ? `&potential=true` : '') + (!!platform ? `&platform=${encodeURIComponent(platform)}` : ''))
}

export const loadOperatorOrders = (appDbPrefix, operatorName, operatorId, before, after, search, page) => {
    return httpCall(httpMethod.GET, `/${appDbPrefix}/operator-orders/${operatorName}/${operatorId}/${page}?after=${after}&before=${before}&search=${search}`)
}


export const loadLastVersion = (appDbPrefix) => httpCall(httpMethod.GET, `/${appDbPrefix}/version`)
export const loadAllVersions = (appDbPrefix) => httpCall(httpMethod.GET, `/${appDbPrefix}/versions`)



export const sendImageData = (appDbPrefix, companyName, codArt, mimeType, content, imageCode) => {
    return httpCall(httpMethod.POST, `/${appDbPrefix}/company/${companyName}/article/${codArt}/img/${imageCode}`, { mimeType: mimeType, content: content });
};
